import React from 'react';
import { Clock, AlertCircle, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  return <section className="py-24 bg-gold text-dark relative overflow-hidden" data-id="element-471" data-mp="2sgg9mbczitrk">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#000 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-472" data-mp="36bsfnewlc6ns"></div>
      {/* Soft glow accents */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/20 rounded-full blur-3xl pointer-events-none" data-id="element-473" data-mp="3b9tvzs2mtrvk"></div>
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-dark/10 rounded-full blur-3xl pointer-events-none" data-id="element-474" data-mp="3p7il5c3qfl6f"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-475" data-mp="3l801ejnndg56">
        {/* Scarcity badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-dark text-white px-4 py-2 rounded-full text-sm font-bold mb-8 shadow-lg" data-id="element-476" data-mp="1qt74mhb12jbn">
          <span className="relative flex h-2.5 w-2.5" data-id="element-477" data-mp="32qj3s05aehmx">
            <span className="absolute inline-flex h-full w-full rounded-full bg-gold opacity-75 animate-ping" data-id="element-478" data-mp="37iu597foebhl"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold" data-id="element-479" data-mp="3cgvnjq5a26s0"></span>
          </span>
          Cupos limitados esta semana
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-480" data-mp="3lhtv2iexcwfc">
          Cada Día Sin Un Website Profesional Es Dinero Que Se Queda En La Mesa
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="space-y-3 text-lg md:text-xl font-medium mb-12 max-w-2xl mx-auto" data-id="element-481" data-mp="1k148w23561d8">
          <p data-id="element-482" data-mp="26z7g8clwstnd">
            Ahora mismo, un homeowner en tu área acaba de buscar tu servicio en
            Google y eligió la opción que se veía más profesional.
          </p>
          <p className="text-2xl font-black" data-id="element-483" data-mp="2gqvfgzopjeze">¿Eras tú?</p>
          <p data-id="element-484" data-mp="2brs99bwzr2pu">Si no — ese trabajo pudo haber sido tuyo.</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="bg-dark text-white rounded-3xl p-8 md:p-10 shadow-2xl text-left" data-id="element-485" data-mp="2qpkn7zmw3j1x">
          <div className="flex flex-col md:flex-row md:items-center gap-8" data-id="element-486" data-mp="2velqf73w0go1">
            <div className="flex-1" data-id="element-487" data-mp="30d6n4wjxki7q">
              <p className="text-xl mb-3" data-id="element-488" data-mp="30c40x1xjz3y5">
                Por solo <strong className="text-gold" data-id="element-489" data-mp="2loaizakzvpce">$125 hoy</strong> puedes
                empezar a cambiar eso.
              </p>
              <p className="text-gray-300 flex items-center gap-2" data-id="element-490" data-mp="2qfiuqd9srmsq">
                <Clock className="w-5 h-5 text-gold shrink-0" data-id="element-491" data-mp="2qgtywe75mwkd" />
                Tu website trabajando en menos de 72 horas.
              </p>
            </div>
            <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="shrink-0 inline-flex items-center justify-center gap-2 px-8 py-4 bg-gold hover:bg-gold-400 text-dark font-bold rounded-full transition-all transform hover:scale-105" data-id="element-492" data-mp="2hngvujfdmekk">
              <MessageCircle className="w-5 h-5" data-id="element-493" data-mp="360c5idxpy51p" />
              Apartar Mi Lugar →
            </a>
          </div>

          <div className="flex items-start gap-4 bg-white/5 p-5 rounded-xl border border-white/10 mt-8" data-id="element-494" data-mp="3192cd3cyojl2">
            <AlertCircle className="w-6 h-6 text-gold shrink-0" data-id="element-495" data-mp="2wbaockffthm5" />
            <p className="text-sm text-gray-400" data-id="element-496" data-mp="2w8odaatc8jz6">
              <strong className="text-white" data-id="element-497" data-mp="2rc7hcufwd1bj">Importante:</strong> trabajamos con
              un número limitado de clientes por semana para garantizar atención
              completa y calidad premium en cada website.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}